import type {GeneratedImagePartActionsProps} from '@Components/ai-chat-window/components/generated-image/generated-image.types';

export const MORE_OPTIONS_DROPDOWN_MODAL_PANEL_ID = 'assistant-message-more-options-dropdown-modal-panel-id';

export interface AssistantMessageImagePartActionsRowProps extends GeneratedImagePartActionsProps {
  chatId: string;
  hashedId: string;
  isMobile?: boolean;
  isLastMessage: boolean;
  isMessageStreaming?: boolean;
  imageWidth?: number;
  imageHeight?: number;
}
